module.exports = __webpack_public_path__ + "static/media/StopGo, Footway Open.dbbd1734.pdf";